import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { createReservation } from '../../../sagas/routines';
import { switchCreateReservationPanel } from '../../../actions/routes/create';
import CreatePanels from '../../../../../constants/reservation/CreatePanels';

const initialState = {
  activePanel: CreatePanels.SEARCH,
  saving: false,
  saved: false
};

export const createReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: set('saved', true),
  [routine.FULFILL]: set('saving', false)
});

const switchCreateReservationPanelHandler = action => ({
  [action.toString()]: (state, { payload: activePanel }) =>
    set('activePanel', activePanel, state)
});

export default createReducer(initialState, {
  ...createReservationHandler(createReservation),
  ...switchCreateReservationPanelHandler(switchCreateReservationPanel)
});
